import { Navigate } from "react-router-dom";

import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { RoleEnum } from "@classview/shared-types";

export function SettingsRedirection() {
  const { hasPermission } = useOrganisation();

  if (hasPermission([RoleEnum.ORGANISATION_MANAGEMENT])) {
    return <Navigate to="/settings/details" />;
  }

  return <Navigate to="/settings/licence" />;
}
